import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WorkspaceFilesUserStatusListCurrentUserWarningDirective } from './workspace-files-user-status-list-current-user-warning.directive';

@NgModule({
  declarations: [
    WorkspaceFilesUserStatusListCurrentUserWarningDirective
  ],
  imports: [
    CommonModule
  ],
  exports: [
    WorkspaceFilesUserStatusListCurrentUserWarningDirective
  ]
})
export class WorkspaceFilesUserStatusListCurrentUserWarningModule { }
